import { Box, Title } from '@factorialco/deprecated-design-system'
import { BenefitsHomePageDocument } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { BenefitsCardBenefitList } from './BenefitsCardBenefitList'

const BenefitsHomePage = () => {
  const { data } = useQuery(BenefitsHomePageDocument)
  const featureAvailabilities = data?.companies?.featureAvailabilitiesConnection?.nodes

  useEffect(() => {
    track(trackingEvents.benefits.openBenefitsHomePage)
  }, [])

  return (
    <ResponsivePage.Body variant="full">
      <Box gap="s32">
        <Title
          variant="400"
          title={i18n.t('benefits.tabs.overview.page.title')}
          description={i18n.t('benefits.tabs.overview.page.description')}
        />

        <BenefitsCardBenefitList showStatus featureAvailabilities={featureAvailabilities} />
      </Box>
    </ResponsivePage.Body>
  )
}

export default BenefitsHomePage
